var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGmailIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 17,
    viewBox: "0 0 22 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.2326 16.127H1.76734C1.06741 16.127 0.5 15.5596 0.5 14.8596V1.76734C0.500041 1.06741 1.06745 0.5 1.76734 0.5H20.2326C20.9325 0.5 21.4999 1.06741 21.4999 1.76734V14.8597C21.4999 15.5596 20.9325 16.127 20.2326 16.127Z",
    fill: "#FAFAFA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.03516 16.1266L20.4068 3.22656V16.1266H3.03516Z",
    fill: "#F5F5F5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.03522 16.127H1.76734C1.06741 16.127 0.5 15.5596 0.5 14.8596V1.76734C0.500041 1.06741 1.06745 0.5 1.76734 0.5H3.03522V16.127Z",
    fill: "#F44336"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.76758 0.5H3.03517V16.127H1.76758V0.5Z",
    fill: "#E53935"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9648 16.127H20.2327C20.9327 16.127 21.5001 15.5596 21.5001 14.8596V1.76734C21.5001 1.06741 20.9327 0.5 20.2327 0.5H18.9648V16.127Z",
    fill: "#F44336"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2324 0.5H18.9648C19.6649 0.5 20.2324 1.06729 20.2324 1.76706V14.8599C20.2324 15.5597 19.6649 16.127 18.9648 16.127H20.2324C20.9325 16.127 21.5 15.5597 21.5 14.8599V1.76706C21.5 1.06729 20.9325 0.5 20.2324 0.5Z",
    fill: "#E53935"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M1.76758 0.5H20.2323V1.7682L10.9999 8.63837L1.76758 1.46817V0.5Z",
    fill: "#FAFAFA"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2491 1.01151C20.8311 0.450167 20.0369 0.333887 19.4754 0.751796L11 7.05869L2.52461 0.751796C1.96306 0.333887 1.16896 0.450208 0.750888 1.01151C0.332856 1.57281 0.449177 2.36658 1.01072 2.78449L10.2431 9.65461C10.4677 9.82179 10.7339 9.90534 11 9.90534C11.2662 9.90534 11.5323 9.82179 11.757 9.65461L20.9893 2.78445C21.5508 2.36658 21.6672 1.57281 21.2491 1.01151Z",
    fill: "#F44336"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2501 1.01127C20.8619 0.489966 20.1493 0.35281 19.5999 0.67064C19.745 0.754394 19.876 0.868335 19.9825 1.01127C20.4006 1.57257 20.2842 2.36635 19.7227 2.78426L10.4904 9.65438C10.4507 9.68391 10.4093 9.70992 10.3672 9.73424C10.5631 9.84752 10.7819 9.90511 11.001 9.90511C11.2672 9.90511 11.5333 9.82156 11.7579 9.65438L20.9903 2.78422C21.5518 2.36635 21.6681 1.57257 21.2501 1.01127Z",
    fill: "#E53935"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGmailIcon);
export default __webpack_public_path__ + "static/media/gmailIcon.c2cd17ff2b7f0fbad0873f83c1296360.svg";
export { ForwardRef as ReactComponent };